// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1spTh","header":"MessagesList_header__1L_M_","chat":"MessagesList_chat__3HTxT"};